export const themes = {
  colorblindDark: {
    co2Scale: {
      steps: [0, 240, 800],
      colors: ['#F0E030', '#F02030', '#002030'],
    },
    oceanColor: '#33414A',
    strokeWidth: 0.3,
    strokeColor: '#6D6D6D',
    clickableFill: '#7A878D',
    nonClickableFill: '#7A878D',
  },
  dark: {
    co2Scale: {
      steps: [0, 150, 600, 750, 800],
      colors: ['#2AA364', '#F5EB4D', '#9E4229', '#381D02', '#381D02'],
    },
    oceanColor: '#33414A',
    strokeWidth: 0.3,
    strokeColor: '#6D6D6D',
    clickableFill: '#7A878D',
    nonClickableFill: '#7A878D',
  },
  colorblindBright: {
    co2Scale: {
      steps: [0, 240, 800],
      colors: ['#F0E030', '#F02030', '#002030'],
    },
    oceanColor: '#FAFAFA',
    strokeWidth: 0.3,
    strokeColor: '#FAFAFA',
    clickableFill: '#D4D9DE',
    nonClickableFill: '#D4D9DE',
  },
  bright: {
    co2Scale: {
      steps: [0, 150, 600, 750, 800],
      colors: ['#2AA364', '#F5EB4D', '#9E4229', '#381D02', '#381D02'],
    },
    oceanColor: '#FAFAFA',
    strokeWidth: 0.3,
    strokeColor: '#FAFAFA',
    clickableFill: '#D4D9DE',
    nonClickableFill: '#D4D9DE',
  },
};
